module.exports = __webpack_public_path__ + "static/media/so.940768f5.svg";